var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('router-link', {
    staticClass: "btn btn-dark font-weight-bolder font-size-sm",
    attrs: {
      "to": {
        name: 'novidadesAdminNovo'
      }
    }
  }, [_vm._v(" + Novo Pacote ")])], 1)]), _c('div', {
    staticClass: "card-body pt-0 pb-3"
  }, [_vm.loading ? _c('div', {
    staticClass: "text-center py-10"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  }), _c('p', {
    staticClass: "mt-3 text-muted"
  }, [_vm._v("Carregando pacotes...")])], 1) : _vm.erro ? _c('div', {
    staticClass: "alert alert-light-danger d-flex align-items-center justify-content-between p-4"
  }, [_c('span', [_vm._v(_vm._s(_vm.erro))]), _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold",
    on: {
      "click": _vm.carregar
    }
  }, [_vm._v(" Tentar novamente ")])]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-head-custom table-head-bg table-borderless table-vertical-center"
  }, [_vm._m(1), _c('tbody', [_vm.pacotes.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-10",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" Nenhum pacote cadastrado ainda. ")])]) : _vm._e(), _vm._l(_vm.pacotes, function (pacote) {
    return _c('tr', {
      key: pacote.id
    }, [_c('td', [_c('span', {
      staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg"
    }, [_vm._v(" " + _vm._s(pacote.titulo) + " ")]), pacote.descricao_curta ? _c('span', {
      staticClass: "text-muted font-weight-bold font-size-sm"
    }, [_vm._v(" " + _vm._s(pacote.descricao_curta) + " ")]) : _vm._e()]), _c('td', [_c('span', {
      staticClass: "text-muted font-weight-bold"
    }, [_vm._v(" " + _vm._s(pacote.versao || "—") + " ")])]), _c('td', [_c('span', {
      staticClass: "text-dark-75 font-weight-bold"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(pacote.data_publicacao)) + " ")])]), _c('td', [_c('span', {
      staticClass: "label label-lg label-inline font-weight-bold",
      class: pacote.publicado ? 'label-light-success' : 'label-light-warning'
    }, [_vm._v(" " + _vm._s(pacote.publicado ? "Publicado" : "Rascunho") + " ")])]), _c('td', [_c('span', {
      staticClass: "label label-lg label-inline font-weight-bold",
      class: pacote.destacar_dashboard ? 'label-light-primary' : 'label-light-secondary'
    }, [_vm._v(" " + _vm._s(pacote.destacar_dashboard ? "Sim" : "Não") + " ")])]), _c('td', [_c('span', {
      staticClass: "label label-lg label-inline font-weight-bold",
      class: pacote.exibir_modal ? 'label-light-info' : 'label-light-secondary'
    }, [_vm._v(" " + _vm._s(pacote.exibir_modal ? "Sim" : "Não") + " ")])]), _c('td', [_c('span', {
      staticClass: "font-weight-bolder text-dark-75"
    }, [_vm._v(" " + _vm._s(pacote.itens ? pacote.itens.length : 0) + " ")])]), _c('td', {
      staticClass: "pr-0 text-right"
    }, [_c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "btn btn-icon btn-light btn-hover-primary btn-sm mr-1",
      attrs: {
        "to": {
          name: 'novidadesAdminEditar',
          params: {
            id: pacote.id
          }
        },
        "title": "Editar"
      }
    }, [_c('Pencil', {
      attrs: {
        "size": 16
      }
    })], 1), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "btn btn-icon btn-sm mr-1",
      class: pacote.publicado ? 'btn-light btn-hover-warning' : 'btn-light btn-hover-success',
      attrs: {
        "title": pacote.publicado ? 'Voltar para rascunho' : 'Publicar'
      },
      on: {
        "click": function click($event) {
          return _vm.togglePublicado(pacote);
        }
      }
    }, [!pacote.publicado ? _c('Check', {
      attrs: {
        "size": 16
      }
    }) : _c('EyeOff', {
      attrs: {
        "size": 16
      }
    })], 1), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "btn btn-icon btn-light btn-hover-danger btn-sm",
      attrs: {
        "title": "Excluir"
      },
      on: {
        "click": function click($event) {
          return _vm.excluir(pacote);
        }
      }
    }, [_c('TrashCan', {
      attrs: {
        "size": 16
      }
    })], 1)], 1)]);
  })], 2)])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" Central de Novidades ")]), _c('span', {
    staticClass: "text-muted mt-3 font-weight-bold font-size-sm"
  }, [_vm._v(" Gerencie os pacotes de novidades do sistema ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', {
    staticClass: "text-left text-uppercase"
  }, [_c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Título")]), _c('th', {
    staticStyle: {
      "min-width": "80px"
    }
  }, [_vm._v("Versão")]), _c('th', {
    staticStyle: {
      "min-width": "120px"
    }
  }, [_vm._v("Data publicação")]), _c('th', {
    staticStyle: {
      "min-width": "90px"
    }
  }, [_vm._v("Status")]), _c('th', {
    staticStyle: {
      "min-width": "80px"
    }
  }, [_vm._v("Destaque")]), _c('th', {
    staticStyle: {
      "min-width": "80px"
    }
  }, [_vm._v("Modal")]), _c('th', {
    staticStyle: {
      "min-width": "70px"
    }
  }, [_vm._v("Itens")]), _c('th', {
    staticStyle: {
      "min-width": "130px"
    }
  }, [_vm._v("Ações")])])]);
}];
export { render, staticRenderFns };